"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformCurrencyToCurrencyISO = void 0;
const legacy_enums_1 = require("@daytrip/legacy-enums");
function transformCurrencyToCurrencyISO(currency) {
    switch (currency) {
        case legacy_enums_1.Currency.Euro:
            return "EUR";
        case legacy_enums_1.Currency.Dollar:
            return "USD";
        case legacy_enums_1.Currency.CanadianDollar:
            return "CAD";
        case legacy_enums_1.Currency.AustralianDollar:
            return "AUD";
        case legacy_enums_1.Currency.BritishPound:
            return "GBP";
        case legacy_enums_1.Currency.NewZealandDollar:
            return "NZD";
        case legacy_enums_1.Currency.CzechKoruna:
            return "CZK";
        case legacy_enums_1.Currency.MexicanPeso:
            return "MXN";
        default:
            throw new Error("Unknown currency");
    }
}
exports.transformCurrencyToCurrencyISO = transformCurrencyToCurrencyISO;
//# sourceMappingURL=transformCurrencyToCurrencyISO.js.map